module.exports = __webpack_public_path__ + "static/img/search.975d4adb.png";